import { Flex, Typography } from '@iheartjane/reefer';
import { Form, useFormContext } from '@iheartjane/reefer-hook-form';

import { useSpecialsModal } from '@jane/business-admin/providers/SpecialsModalProvider';
import type { SpecialTypeProps } from '@jane/business-admin/types';

export const CartTotal = ({
  isCreateMode,
  name,
}: SpecialTypeProps['cart_total'] & {
  isCreateMode: boolean;
}) => {
  const {
    posSyncMap: { isJanePosSynced, posSynced },
    isReadOnly,
  } = useSpecialsModal();

  const { getValues } = useFormContext();

  const cartTotalValue = getValues(`${name}.threshold`);
  const showInputs = (isJanePosSynced || !posSynced) && !isReadOnly;

  return (
    <Flex mb={24} width="100%" flexDirection="column">
      {isCreateMode || (!isCreateMode && showInputs) ? (
        <>
          <Form.NumberField
            width="50%"
            name={`${name}.threshold`}
            label="Cart total threshold"
            mb={4}
            disableOnWheel
          />
          <Typography color="grays-mid" mt={16}>
            Enter the cart total the customer must reach to activate this
            special.
          </Typography>
        </>
      ) : (
        <Flex width="50%" flexDirection="column">
          <Typography
            color="grays-black"
            variant="body-semibold"
            data-testid="non-janepos-synced-cart-total-threshold"
          >
            Cart total threshold
          </Typography>
          <Typography color="grays-black" mt={4}>
            {cartTotalValue}
          </Typography>
        </Flex>
      )}
    </Flex>
  );
};
